import { req, post, get } from '@/plugins/axios'
import type { res } from './login'
import { Site } from '@/common/const'
import { useSite2Station, isJA } from '@/store'

// 类目
interface GCD {
  channel: number
}

export const getCategory = (data: { stationCode: Site }): Promise<res> =>
  post('/goods/productCategoryFrontend/tree', data)

// 快捷类目
export const fastCategory = (data: GCD): Promise<res> =>
  req('/goods/fastCategory', data)

// 搜索
export interface SPD {
  channel?: number
  keyword?: string
  langType?: number | string
  platformType?: string
  productCode?: string
  productCategoryFrontendId?: string
  sellPriceStart?: number
  sellPriceEnd?: number
  sortType?: string
  descendOrder?: boolean
  pageNum?: number
  pageSize?: number
  productMallFrontendId?: string
  carefullySelected?: number;
  /** 渠道列表 */
  channelList?: number[]
  [key: string]: any
  notChoice?: number
}

export const searchProducts = (data: SPD): Promise<res> => {
  const formData = { ...data }
  if (formData.platformType && formData.platformType.split('SC').length > 1) {
    formData.productMallFrontendId = formData.platformType.replace('SC', '')
    formData.platformType = ''
  }
  // 在api下单关联商品页面排除掉线下商品, 只传线上和档口
  const isCreateAssociatedPage = window.location.pathname.endsWith('/product/CreateAssociated')
  if (isCreateAssociatedPage) {
    formData.channelList = [1, 2]
  }
  if (formData.isOnePsale) {
    if (formData.isOnePsale === 'true') {
      formData.isOnePsale = true
    } else {
      delete formData.isOnePsale
    }
  }
  delete formData.schannel

  if (formData.platformType === 'choice') {
    formData.platformType = ''
    formData.carefullySelected = 1
  }
  if (formData.productCategoryFrontendId === '-1') {
    delete formData.productCategoryFrontendId
  }
  formData.notChoice = 1
  // const isGrayUser = location.pathname.startsWith('/next/') && isJA()
  // formData.abUser = isGrayUser
  return post('/goods/search/products', formData)
}
interface SSS {
  pageNum: number
  pageSize: number
  shopCode?: string
  productCode?: string
  imageId?: string;
}
// 相似商品
export const searchSimilar = (data: SSS): Promise<res> => {
  const formData: any = { ...data }
  if (formData.platformType && formData.platformType.split('SC').length > 1) {
    formData.productMallFrontendId = formData.platformType.replace('SC', '')
    formData.platformType = ''
  }
  return post('/goods/similarSearch/product', formData)
}

export const searchSimilarShop = (data: SSS): Promise<res> =>
  post('/goods/similarSearch/supplier', data)

// 根据url搜索商品
interface SUD {
  detailUrl: string
  from?: string
  channelList?: number[]
  notChoice?: number
}
export const searchUrl = (data: SUD): Promise<res> =>
  post('/goods/search/url', data)

// 商品详情
interface PDD {
  productCode: string
}
export const productDetail = (data: PDD): Promise<res> =>
  post('/goods/product/detail', data)

export const productSkus = (data: any): Promise<res> =>
  req('/goods/product/skus', data)

// 商品详情【兼容1688实时接口】
export const productNewDetail = (data: PDD): Promise<res> =>
  post('/goods/product/newDetail', data)

// 是否收藏
export const productHasFavo = (data: PDD): Promise<res> =>
  req('/goods/favorite/product/isFavorite', data)

// 供应商详情
interface SDD {
  shopCode: string
}
export const supplierDetail = (data: SDD): Promise<res> =>
  post('/goods/supplier/detail', data)

// 获取店铺信息和商品列表
export const searchSuppliers = (data: any): Promise<res> =>
  post('/goods/search/suppliers', { ...data, needTranslateTitle: true })

// 获取历史搜索关键词
export const getHistorySearch = (data: any): Promise<res> =>
  req('/goods/search/keyword/history', {
    ...data,
    stationCode: useSite2Station()
  })

// 获取热搜关键词
export const getHotSearch = (data: any): Promise<res> =>
  req('/goods/search/keyword/host', {
    ...data,
    stationCode: useSite2Station()
  })

// 添加商品至店铺
export const batchSaveIfAbsent = (data: any): Promise<res> =>
  post('/order/customer/productSku/batchSaveIfAbsent', data)

// 无水印图配置
export const getListImageConfig = (data: any): Promise<res> =>
  get('/goods/image/search/listImageConfig', data)

// 用户无水印使用详情
export const getUserUsageInfo = (data: any): Promise<res> =>
  req('/goods/image/search/userUsageInfo', data)

// 使用精选货源无水印图片
export const postAddNum = (data: PDD): Promise<res> =>
  post('/goods/image/search/addNum', data)

interface DTO {
  imageUrl: string;
  imageId: string;
  productCode?: string;
  pageNum?: number;
  pageSize?: number;

}

// 图搜新接口
export const searchList = (data: DTO): Promise<res> =>
  post('/goods/image/search/list', data)

interface DTB {
  imageBase64?: string;
  imageUrl?: string;
}
export const searchUpload = (data: DTB): Promise<res> =>
  post('/goods/image/search/upload', data)

type AgreeParams = {
  keyWords?: string;
  filters?: string;
  // 是否满意0-否 1-是
  agreeFlag: 0 | 1;
  // 不满意的点
  comments?: string;
  categoryId?: string;
}
// 满意度调查
export const checkAgree = (data: AgreeParams): Promise<res> =>
  post('/goods/product/checkAgree', data)
